import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { messages as enMessages } from './locales/en/messages';
import { messages as esMessages } from './locales/es/messages';
import { messages as frMessages } from './locales/fr/messages';
import { messages as ruMessages } from './locales/ru/messages';
import { messages as tgMessages } from './locales/tg/messages';
// import '@fontsource/noto-sans-arabic/400.css'
// import '@fontsource/noto-sans-arabic/700.css'
import './index.css';
import App from './App';
import { SUPPORTED_LOCALES } from './consts/supported-locales';
import { FORCE_MARKET_LOCALE, getBuildDefaultLocale } from './config/market';
import { registerAppServiceWorker } from './pwa/register-service-worker';
import { requestStoragePersistence } from './offline/storage-persist';

const container = document.getElementById('root');

export function getPreferredLocale(supportedLocales) {
  // Check localStorage/sessionStorage
  const storedLang = localStorage.getItem('preferredLanguage');
  if (storedLang && supportedLocales.includes(storedLang)) {
    return storedLang;
  }

  if (FORCE_MARKET_LOCALE) {
    return getBuildDefaultLocale();
  }

  // Detect browser language with fallback
  const browserLanguage = navigator.language || navigator.userLanguage;

  // Check full language code (e.g., 'en-US')
  if (browserLanguage && supportedLocales.includes(browserLanguage)) {
    return browserLanguage;
  }

  // Check base language (e.g., 'en' from 'en-US')
  const baseLanguage = browserLanguage.split('-')[0];
  if (baseLanguage && supportedLocales.includes(baseLanguage)) {
    return baseLanguage;
  }

  return getBuildDefaultLocale();
}

// i18n.load('en', enMessages)
i18n.load({
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ru: ruMessages,
  tg: tgMessages
});

i18n.activate(getPreferredLocale(SUPPORTED_LOCALES));

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    registerAppServiceWorker().catch((error) => {

    });
    requestStoragePersistence().catch(() => {});
  });
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>);